module.exports = __webpack_public_path__ + "img/canbadge_daishi_115_140mm.0132663b.png";